import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=2d45de0c&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"
import style0 from "./InputText.scss?vue&type=style&index=0&id=2d45de0c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45de0c",
  null
  
)

export default component.exports